import { ReactNode } from 'react'
import styled from 'styled-components'

export interface GridEmptyStateProps {
  colSpan: number
  title?: string
  subtitle?: string
  icon?: ReactNode
}

const DefaultIcon = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 9h18M9 4v16" />
  </svg>
)

export const GridEmptyState = ({
  colSpan,
  title = 'לא נמצאו רשומות',
  subtitle = 'שנה את הסינון או צור רשומה חדשה.',
  icon,
}: GridEmptyStateProps) => (
  <tr>
    <td colSpan={colSpan}>
      <Wrap>
        <IconTile>{icon ?? DefaultIcon}</IconTile>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Wrap>
    </td>
  </tr>
)

export default GridEmptyState

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 56px 18px;
`

const IconTile = styled.div`
  width: 52px;
  height: 52px;
  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ theme }) => theme.colors.bgLayout};
  border: 1px solid ${({ theme }) => theme.colors.line};
  display: grid;
  place-items: center;
  color: ${({ theme }) => theme.colors.icon};
  margin-bottom: 14px;

  svg {
    width: 24px;
    height: 24px;
  }
`

const Title = styled.h5`
  font-size: ${({ theme }) => theme.text.lg};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.ink};
  margin-bottom: 4px;
`

const Subtitle = styled.p`
  font-size: ${({ theme }) => theme.text.md};
  color: ${({ theme }) => theme.colors.ink3};
  max-width: 30ch;
`
